export default {
  workspaceUsers(state) {
    return state.workspaceUsers;
  },
  workspaceUserGroups(state) {
    return state.workspaceUserGroups;
  },
  workspaceUserGroupsForSelect(state) {
    return state.workspaceUserGroups.map((group) => ({
      id: group.id,
      text: group.name,
    }));
  },
  workspaceSelectedUserGroupsForSelect(state) {
    return state.workspaceUserGroups
      .filter((group) => group.isSelected)
      .map((group) => group.id);
  },
};
